import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createSessionStoragePersist } from "../utils/sessionStoragePersist";

interface ForecastStore {
  dailyCache: { date: string; forecast: string } | null;
  tomorrowCache: { date: string; forecast: string } | null;
  weeklyCache: { week: string; forecast: string } | null;
  monthlyCache: { month: string; forecast: string } | null;
  yearlyCache: { year: number; forecast: string } | null;

  setDailyForecast: (date: string, forecast: string) => void;
  setTomorrowForecast: (date: string, forecast: string) => void;
  setWeeklyForecast: (week: string, forecast: string) => void;
  setMonthlyForecast: (month: string, forecast: string) => void;
  setYearlyForecast: (year: number, forecast: string) => void;
  clearForecasts: () => void;
}

export const useForecastStore = create<ForecastStore>()(
  persist(
    (set) => ({
      dailyCache: null,
      tomorrowCache: null,
      weeklyCache: null,
      monthlyCache: null,
      yearlyCache: null,

      setDailyForecast: (date, forecast) => set({ dailyCache: { date, forecast } }),

      setTomorrowForecast: (date, forecast) => set({ tomorrowCache: { date, forecast } }),

      setWeeklyForecast: (week, forecast) => set({ weeklyCache: { week, forecast } }),

      setMonthlyForecast: (month, forecast) => set({ monthlyCache: { month, forecast } }),

      setYearlyForecast: (year, forecast) => set({ yearlyCache: { year, forecast } }),

      clearForecasts: () =>
        set({
          dailyCache: null,
          tomorrowCache: null,
          weeklyCache: null,
          monthlyCache: null,
          yearlyCache: null,
        }),
    }),
    createSessionStoragePersist<ForecastStore>(
      "forecast",
      (state) =>
        ({
          dailyCache: state.dailyCache,
          tomorrowCache: state.tomorrowCache,
          weeklyCache: state.weeklyCache,
          monthlyCache: state.monthlyCache,
          yearlyCache: state.yearlyCache,
        } as ForecastStore)
    )
  )
);
